export const getHeaderOffset = () => {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--site-header-total-height');
  const parsed = parseInt(raw, 10);
  const header = Number.isFinite(parsed) && parsed > 0 ? parsed : 158;
  const subnav = document.querySelector('.program-subnav');
  const subnavHeight = subnav ? subnav.getBoundingClientRect().height : 0;
  return header + subnavHeight;
};

export const scrollToProgramSection = (id, behavior = 'smooth') => {
  const target = document.getElementById(id);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 8;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
};

export const scrollToPageTop = (behavior = 'auto') => {
  window.scrollTo({ top: 0, behavior });
};
